<template>
  <text-area-field
    v-model="innerAsins"
    class="mb-12"
    name="ASIN"
    label="ASIN"
    placeholder="改行で複数ASINの一括登録が可能"
    rules="required"
  />
</template>

<script>
import TextAreaField from '@/components/fields/TextAreaField'

export default {
  name: 'MonitoringAsinForm',
  components: {
    TextAreaField
  },
  props: {
    asins: {
      type: String,
      default: null
    }
  },
  emits: ['update:asins'],
  computed: {
    innerAsins: {
      get () {
        return this.asins
      },
      set (value) {
        this.$emit('update:asins', value)
      }
    }
  }
}
</script>

<style>
</style>
